<div class="d-flex flex-column shape-info-window">
  <div class="d-flex flex-column shape-info" *ngIf="!distance">
    <fieldset>
        <label class="highlight-text" for="shapeName">Shape Name</label>
        <input id="shapeName" class="form-control" value="{{name}}" (change)="nameChange.emit($event.target.value)">
    </fieldset>

    <div>
      <span class="highlight-text">Shape area: </span> <span>{{getDrawnArea(area, 'area')}}</span>
    </div>
    <div *ngIf="radius">
      <span class="highlight-text">Radius: </span><span>{{getDrawnArea(radius, 'radius')}}</span>
    </div>
  </div>
  <div class="total-info" *ngIf="!distance" [ngClass]="{'max-area': maxTotalArea < totalArea}">
    <span class="highlight-text">Total Shape(s) Area: </span> <span>{{getDrawnArea(totalArea, 'totalArea')}}</span>
  </div>
  <div class="shape-info distance" *ngIf="distance">
    <span><span class="highlight-text">Total Length:</span> {{getRulerDistance(distance)}}</span>
  </div>
  <div class="d-flex btn-group control-group">
    <button class="btn white-button"
            [ngClass]="{'d-flex justify-content-center': distance}"
            (click)="deleteShape.emit()">
      <i class="fa fa-trash-o" aria-hidden="true"></i>
      <span>{{distance ? 'Delete Line' : 'Delete Shape'}}</span>
    </button>
    <button class="btn btn-primary m-0" *ngIf="!distance" (click)="submitSearch.emit()">Search</button>
  </div>
</div>
